import { CircularProgress, Stack, Typography, useTheme } from "@mui/material";

export default function LoadingUpdate({
  elementSelected,
  visible = false,
  customStyle,
  rulerMode,
}) {
  const theme = useTheme();
  const styles = {
    container: {
      position: "absolute",
      zIndex: 1000,
      top: rulerMode ? 70 : 10,
      right: elementSelected ? 370 : 15,
      backgroundColor: theme.palette.background.default,
      padding: "10px 15px",
      borderRadius: "4px",
      border: "1px solid" + theme.palette.color.appBarBorder,
    },
  };
  return (
    visible && (
      <Stack
        sx={{ ...styles.container, ...customStyle }}
        direction={"row"}
        alignItems={"center"}
        gap={2}
      >
        <CircularProgress size="25px" />
        <Typography>Sincronizando...</Typography>
      </Stack>
    )
  );
}
